import React, { useState } from "react";
import AccordionTextItem, { AccordionTextItemType } from "./AccordionTextItem";
import { ComponentBackgroundColor } from "types/componentBackground";

export interface AccordionTextProps {
  items: AccordionTextItemType[];
  backgroundColor?: ComponentBackgroundColor;
}

const AccordionText: React.FC<AccordionTextProps> = ({
  items,
  backgroundColor
}) => {
  const [expandedItem, setExpandedItem] = useState<string | undefined>(
    undefined
  );

  const toggleExpanedItem = (key: string | undefined) => {
    if (expandedItem == key) setExpandedItem(undefined);
    else setExpandedItem(key);
  };

  return (
    <div>
      {items.map((item) => (
        <AccordionTextItem
          backgroundColor={backgroundColor}
          key={item._key}
          item={item}
          isExpanded={expandedItem == item._key}
          setToggleExpanded={() => toggleExpanedItem(item._key)}
        />
      ))}
    </div>
  );
};

export default AccordionText;
